$(document).ready(function(){
 $('.slick-carousel').slick({
	infinite: true,
	speed: 300,
	slidesToShow: 4,
	dots: false,
    adaptiveHeight: true,
	slidesToScroll: 1,
    prevArrow:'<svg class="slick-arrow-left" width="12" height="25" viewBox="0 0 12 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 24.5L0 12.5L12 0.5" fill="#C8102E"/></svg>',
    nextArrow:'<svg class="slick-arrow-right" width="12" height="25" viewBox="0 0 12 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 24.5L12 12.5L0 0.5" fill="#C8102E"/></svg>',

	responsive: [
      {
			breakpoint: 1200,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				infinite: true,
				dots: false
			}
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				dots: false,
                infinite: true,
                adaptiveHeight: true,
				slidesToScroll: 1
			}
		}
	]
});

  $('.list_collection_home').slick({
	infinite: true,
	speed: 300,
	slidesToShow: 3,
	dots: false,
    adaptiveHeight: true,
	slidesToScroll: 1,
    prevArrow:'<svg class="slick-arrow-left" width="12" height="25" viewBox="0 0 12 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 24.5L0 12.5L12 0.5" fill="#750D05"/></svg>',
    nextArrow:'<svg class="slick-arrow-right" width="12" height="25" viewBox="0 0 12 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 24.5L12 12.5L0 0.5" fill="#750D05"/></svg>',

	responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				infinite: true,
				dots: false
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 599,
			settings: {
				slidesToShow: 1,
				dots: false,
				slidesToScroll: 1
			}
		}
	]
});
  
// 
  $('.header nav.header__inline-menu li').mouseover(function() {
    $('.header nav.header__inline-menu .mega-menu').attr('open', false);
    $(this).find('.mega-menu').attr('open', true);
    $(this).find('.fhNUrG').addClass('dTnuRg');
    $(this).find('.jYVJqC').addClass('dTnuRg');
  });
  $('.header nav.header__inline-menu').mouseout(function(){   
   $('.header nav.header__inline-menu .mega-menu').attr('open', false);
   $(this).find('.fhNUrG').removeClass('dTnuRg');
   $(this).find('.jYVJqC').removeClass('dTnuRg');
  });

  document.querySelectorAll('.header.psc-header').forEach(function(header) {
    var dropdownCloseTimer;
    var dropdowns = Array.from(header.querySelectorAll('.psc-nav-dropdown-trigger')).map(function(trigger) {
      return {
        trigger: trigger,
        panel: document.getElementById(trigger.getAttribute('aria-controls'))
      };
    }).filter(function(dropdown) {
      return dropdown.panel;
    });

    function isInsideDropdown(dropdown, element) {
      return element && (dropdown.trigger.contains(element) || dropdown.panel.contains(element));
    }

    function closeDropdown(dropdown, returnFocus) {
      dropdown.panel.hidden = true;
      dropdown.trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) dropdown.trigger.focus();
    }

    function closeOtherDropdowns(activeDropdown) {
      dropdowns.forEach(function(dropdown) {
        if (dropdown !== activeDropdown) closeDropdown(dropdown, false);
      });
    }

    function openDropdown(dropdown) {
      clearTimeout(dropdownCloseTimer);
      closeOtherDropdowns(dropdown);
      dropdown.panel.hidden = false;
      dropdown.trigger.setAttribute('aria-expanded', 'true');
    }

    function scheduleDropdownClose(dropdown, event) {
      if (isInsideDropdown(dropdown, event.relatedTarget)) return;

      clearTimeout(dropdownCloseTimer);
      dropdownCloseTimer = setTimeout(function() {
        if (dropdown.trigger.matches(':hover') || dropdown.panel.matches(':hover')) return;
        if (isInsideDropdown(dropdown, document.activeElement)) return;
        closeDropdown(dropdown, false);
      }, 400);
    }

    dropdowns.forEach(function(dropdown) {
      $(dropdown.trigger).on('mouseenter focusin', function() {
        openDropdown(dropdown);
      });

      $(dropdown.panel).on('mouseenter focusin', function() {
        clearTimeout(dropdownCloseTimer);
      });

      $(dropdown.trigger).add(dropdown.panel).on('mouseleave focusout', function(event) {
        scheduleDropdownClose(dropdown, event);
      });

      $(dropdown.trigger).on('keydown', function(event) {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        openDropdown(dropdown);
        var firstDropdownLink = dropdown.panel.querySelector('a');
        if (firstDropdownLink) firstDropdownLink.focus();
      });
    });

    $(document).on('keydown', function(event) {
      if (event.key !== 'Escape') return;
      var openDropdownItem = dropdowns.find(function(dropdown) {
        return dropdown.trigger.getAttribute('aria-expanded') === 'true';
      });
      if (openDropdownItem) closeDropdown(openDropdownItem, true);
    });

    $(document).on('click', function(event) {
      var clickedInsideDropdown = dropdowns.some(function(dropdown) {
        return isInsideDropdown(dropdown, event.target);
      });
      if (!clickedInsideDropdown) closeOtherDropdowns();
    });
  });
  
   $("#toggle-slow").click(function() {
          $("#box"). slideToggle("slow");
     });

  //
  
  $(".hot-spot__dot,.popup_cancel").click(function(){
    $(this).closest('.hot-spot').find(".hot-spot-popover").fadeToggle();    
    var cls = $(this).closest('.hot-spot').hasClass("dot_tab");
    if(cls){
        $(this).closest('.hot-spot').removeClass("dot_tab");
    }else{
      $(this).closest('.hot-spot').addClass("dot_tab").siblings().removeClass("dot_tab");
    }    
    var id=$(this).attr("aria-controls"); 	 
    $(".hot-spot").find(".hot-spot-popover").not("#"+id).fadeOut();
  });
     
});   


  $(document).ready(function(){
   (function(e){if(typeof define==="function"&&define.amd){define(["jquery"],e)}else if(typeof exports==="object"){e(require("jquery"))}else{e(jQuery)}})(function(e){function n(e){return u.raw?e:encodeURIComponent(e)}function r(e){return u.raw?e:decodeURIComponent(e)}function i(e){return n(u.json?JSON.stringify(e):String(e))}function s(e){if(e.indexOf('"')===0){e=e.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\")}try{e=decodeURIComponent(e.replace(t," "));return u.json?JSON.parse(e):e}catch(n){}}function o(t,n){var r=u.raw?t:s(t);return e.isFunction(n)?n(r):r}var t=/\+/g;var u=e.cookie=function(t,s,a){if(s!==undefined&&!e.isFunction(s)){a=e.extend({},u.defaults,a);if(typeof a.expires==="number"){var f=a.expires,l=a.expires=new Date;l.setTime(+l+f*864e5)}return document.cookie=[n(t),"=",i(s),a.expires?"; expires="+a.expires.toUTCString():"",a.path?"; path="+a.path:"",a.domain?"; domain="+a.domain:"",a.secure?"; secure":""].join("")}var c=t?undefined:{};var h=document.cookie?document.cookie.split("; "):[];for(var p=0,d=h.length;p<d;p++){var v=h[p].split("=");var m=r(v.shift());var g=v.join("=");if(t&&t===m){c=o(g,s);break}if(!t&&(g=o(g))!==undefined){c[m]=g}}return c};u.defaults={};e.removeCookie=function(t,n){if(e.cookie(t)===undefined){return false}e.cookie(t,"",e.extend({},n,{expires:-1}));return!e.cookie(t)}})
    
  $(".itgr-newsletter-close").click(function(){
    $.cookie('jqcookie','verificationpopup', {
      expires: 1
    });
  
    $(".itgr-newsletter-popup").fadeOut();
    $('.site-header').removeClass('remove_index');
  });
  
  var main_page = $.cookie('jqcookie');
  if(main_page == 'verificationpopup'){
    //$('.custom_popup').hide();
  } else {
    setTimeout(function(){
      $(".itgr-newsletter-popup").fadeIn();
    },2000);
  }

});
